module.exports = __webpack_public_path__ + "img/bill-invalid.1a75d1c6.png";